import { render, staticRenderFns } from "./PropertyBase.vue?vue&type=template&id=62cae791&"
import script from "./PropertyBase.vue?vue&type=script&lang=js&"
export * from "./PropertyBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports